module.exports = __webpack_public_path__ + "static/img/news_xiangqing_tu4.4354556.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_xiangqing_tu4.png
// module id = kyB/
// module chunks = 0